import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { DashSelection } from './app.model';

@Component({
    components: {
        MenuComponent: require('../navmenu/navmenu.vue.html').default,
        ContentComponent: require('../content/content.vue.html').default,
        HeaderComponent: require('../header/header.vue.html').default
    }
})
export default class AppComponent extends Vue {
    selection: DashSelection;

    constructor() {
        super();
        let start = new Date();
        start.setHours(0, 0, 0, 0);
        this.selection = new DashSelection(start, 'day', 'EDA');

        // let e: string[] = [];
        // let date = new Date(2021, 1, 14).getTime();
        // for (let d = 0; d < 31; d++) {
        //     for (let h = 0; h < 24; h++) {
        //         for (let m = 0; m < 12; m++) {
        //             let nd = date + d * 24 * 60 * 60 * 1000
        //                 + h * 60 * 60 * 1000
        //                 + m * 5 * 60 * 1000;
        //             e.push("('" + new Date(nd).toISOString().replace('T', ' ').replace('Z', '') + "'," + (Math.random() * 100) + "," + (Math.random() * 100) + ")");
        //         }
        //     }
        // }
        // let s = "INSERT INTO ct (d, c, t) VALUES " + e.reduce((l, r) => l + "," + r);
        // console.log(s);
    }
}
